export default "__VITE_ASSET__CxZ16X3I__"